module.exports = __webpack_public_path__ + "static/media/logo.25fffe10.png";